import React from "react";

export const SubMenuIcons = () => {
    return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="5.79688" cy="5.69873" r="4.55" stroke="white" strokeWidth="0.9"/>
    </svg>    
    );
}
